export default __webpack_public_path__ + "static/omni-5-9b62c4a50353f00520c6da4a1ac1ddb5.webp";